/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_RoleInputs */

const en_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROLE`)
};

const fr_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROLE`)
};

const de_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROLLE`)
};

const it_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RUOLO`)
};

const ru_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`РОЛЬ`)
};

const es_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROLE`)
};

const zh_cn2_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const ja_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`役割`)
};

const hi_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भूमिका`)
};

const pt_pt2_ccsl_export_header_role = /** @type {(inputs: Ccsl_Export_Header_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAPEL`)
};

/**
* | output |
* | --- |
* | "ROLE" |
*
* @param {Ccsl_Export_Header_RoleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_role = /** @type {((inputs?: Ccsl_Export_Header_RoleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_RoleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_role(inputs)
	if (locale === "de") return de_ccsl_export_header_role(inputs)
	if (locale === "it") return it_ccsl_export_header_role(inputs)
	if (locale === "ru") return ru_ccsl_export_header_role(inputs)
	if (locale === "es") return es_ccsl_export_header_role(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_role(inputs)
	if (locale === "ja") return ja_ccsl_export_header_role(inputs)
	if (locale === "hi") return hi_ccsl_export_header_role(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_role(inputs)
	return en_ccsl_export_header_role(inputs)
});